export default __webpack_public_path__ + "static/media/shutterstock_1751484320_formacion_3.57b5aa8e.webp";